//   Helper function to safely get string value from field (handles object or string)
const getStringValue = (value, defaultValue = 'N/A') => {
    if (!value) return defaultValue;
    if (typeof value === 'string') return value;
    if (typeof value === 'object') {
        // Handle objects like { _id, name }
        return value.name || value.title || value.label || JSON.stringify(value);
    }
    return String(value);
};

export default getStringValue;